import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-crm-callback',
  templateUrl: './crm-callback.component.html',
  styleUrls: ['./crm-callback.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class CrmCallbackComponent implements OnInit {
  processing = true;
  status: 'success' | 'error' = 'error';
  crmType: string = 'unknown';
  errorMessage: string | null = null;
  private startTimeMs = 0;

  constructor(private route: ActivatedRoute) {}

  ngOnInit(): void {
    // mark start to guarantee a minimum spinner display duration
    this.startTimeMs = performance.now();
    this.handleOAuthCallback();
  }

  private handleOAuthCallback(): void {
    const params = this.route.snapshot.queryParams;
    this.status = (params['status'] as 'success' | 'error') || 'error';
    this.crmType = params['crm_type'] || 'unknown';
    this.errorMessage = params['error_description'] || params['error'] || null;

    // Ensure spinner is visible at least 1.2 seconds
    const elapsed = performance.now() - this.startTimeMs;
    const remaining = Math.max(0, 1200 - elapsed);
    setTimeout(() => {
      this.processing = false;
      // After showing the final status, give the user time to read it before closing
      setTimeout(() => {
        window.close();
      }, 3000);
    }, remaining);
  }
}
